import AppIconComponent from './AppIcon';

export const AppIcon = AppIconComponent;
export * from './Library';
